// truncate text to max n chars eventualli adding "..."
export const truncText = (text: string | undefined, n: number) => (!text ? "" : text.length > n ? text.substring(0, n) + "..." : text);
